/* unplugin-vue-components disabled */import { render } from "./HeaderPlus.vue?vue&type=template&id=60ee749a&scoped=true&ts=true"
import script from "./HeaderPlus.vue?vue&type=script&lang=ts"
export * from "./HeaderPlus.vue?vue&type=script&lang=ts"

import "./HeaderPlus.vue?vue&type=style&index=0&id=60ee749a&lang=scss"
import "./HeaderPlus.vue?vue&type=style&index=1&id=60ee749a&lang=scss&scoped=true"

import exportComponent from "/var/static/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ee749a"]])

export default __exports__